function AppointmentsPrinter() {

    this.appointmentServiceURL = '/qless/merchant/printAppointments/'

    /**
	* Method to create URL to access printable appointments for a given day
	*
	* @method appointmentURL
    * @param {Object} printAppointmentProps object containing information about the state of parent model
	* @return {String}
	*/
    this.appointmentURL = function (printAppointmentProps) {
        return this.appointmentServiceURL + 
               "?queueIds=" + printAppointmentProps.queues.join(',') +
               "&locationIds=" + printAppointmentProps.locations.join(',')  +             
               "&start=" + printAppointmentProps.range.start +
               "&end=" + printAppointmentProps.range.end +
               '&timeZone=' + printAppointmentProps.timeZone +
               "&locale=" + printAppointmentProps.lang
    }

    /**
	* Opens a new window with a given print URL
	*
	* @method print
    * @param {Moment} date 
    * @param {Array} queueIds
    * @param {Array} locationids
    * @param {String} timeZone
    * @param {String} locale
	*/
    this.print = function (date, queueIds, locationIds, timeZone, locale) { 
        var printAppointmentProps = {
            range: printAppointmentRange(date),
            queues: queueIds,
            locations: locationIds,
            timeZone : timeZone,
            lang: locale,
        };

        var appointmentURL = this.appointmentURL(printAppointmentProps);
        openWindow(appointmentURL);
    }

    return this;
  };

  if (typeof exports !== "undefined") {
      exports.AppointmentsPrinter = AppointmentsPrinter;
  }
  